import { render, staticRenderFns } from "./IpLists.vue?vue&type=template&id=07fd173a&scoped=true&"
import script from "./IpLists.vue?vue&type=script&lang=js&"
export * from "./IpLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fd173a",
  null
  
)

export default component.exports